"use client";

import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps, ReactNode } from "react";
import { cn } from "../../lib/utils";

const labelVariants = cva(
  "font-semibold text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      variant: {
        default: "text-zinc-900",
        muted: "text-zinc-500",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export type LabelProps = ComponentProps<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants> & {
    disabled?: boolean;
  };

export function Label(props: LabelProps): ReactNode {
  const { variant, className, disabled, ...restProps } = props;

  return (
    <LabelPrimitive.Root
      className={cn(labelVariants({ variant }), disabled, className)}
      {...restProps}
    />
  );
}
